/*
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { emit } from '@nextcloud/event-bus';
var PostMessageService = /** @class */ (function () {
    function PostMessageService(targets) {
        var _this = this;
        this.postMessageHandlers = [];
        this.allowedOrigins = [];
        this.targetOrigins = {};
        this.targets = targets;
        window.addEventListener('message', function (event) {
            if (_this.allowedOrigins.length > 0 && !_this.allowedOrigins.includes(event.origin)) {
                console.warn('PostMessageService: rejected message from unexpected origin', event.origin);
                return;
            }
            _this.handlePostMessage(event.data);
        }, false);
    }
    PostMessageService.prototype.setAllowedOrigins = function (origins) {
        this.allowedOrigins = origins;
    };
    PostMessageService.prototype.setTargetOrigins = function (origins) {
        this.targetOrigins = origins;
    };
    PostMessageService.prototype.sendPostMessage = function (target, message, targetOrigin) {
        var _a;
        var targetElement;
        if (typeof this.targets[target] === 'function') {
            targetElement = this.targets[target]();
        }
        else {
            targetElement = this.targets[target];
        }
        var origin = (_a = targetOrigin !== null && targetOrigin !== void 0 ? targetOrigin : this.targetOrigins[target]) !== null && _a !== void 0 ? _a : '*';
        targetElement.postMessage(message, origin);
        console.debug('PostMessageService.sendPostMessage', target, message);
    };
    PostMessageService.prototype.sendWOPIPostMessage = function (target, msgId, values) {
        if (values === void 0) { values = {}; }
        var msg = {
            MessageId: msgId,
            SendTime: Date.now(),
            Values: values,
        };
        this.sendPostMessage(target, JSON.stringify(msg));
    };
    PostMessageService.parsePostMessage = function (data) {
        var msgId, args, deprecated;
        try {
            var msg = JSON.parse(data);
            msgId = msg.MessageId;
            args = msg.Values;
            deprecated = !!msg.Values.Deprecated;
        }
        catch (exc) {
            msgId = data;
        }
        return { msgId: msgId, args: args, deprecated: deprecated };
    };
    PostMessageService.prototype.registerPostMessageHandler = function (callback) {
        this.postMessageHandlers.push(callback);
    };
    PostMessageService.prototype.unregisterPostMessageHandler = function (callback) {
        var handlerIndex = this.postMessageHandlers.findIndex(function (cb) { return cb === callback; });
        delete this.postMessageHandlers[handlerIndex];
    };
    PostMessageService.prototype.handlePostMessage = function (data) {
        var parsed = PostMessageService.parsePostMessage(data);
        if (typeof parsed === 'undefined' || parsed === null) {
            return;
        }
        try {
            var wopiPostMessage = JSON.parse(data);
            if (typeof wopiPostMessage === 'object' && wopiPostMessage !== null) {
                emit('richdocuments:wopi-post', wopiPostMessage);
            }
        }
        catch (e) { }
        this.postMessageHandlers.forEach(function (fn) {
            if (parsed.deprecated) {
                console.debug('PostMessageService.handlePostMessage', 'Ignoring deprecated post message', parsed.msgId);
                return;
            }
            try {
                fn({
                    data: data,
                    parsed: parsed,
                });
            }
            catch (e) {
                console.error('Error during post message handler', parsed, e);
            }
        });
    };
    return PostMessageService;
}());
export default PostMessageService;
